import authService from './AuthorizeService';

const authorizedFetch = async (input, init) => {
    const token = await authService.getAccessToken();
    init = init ?? {};
    init.headers = init.headers ?? {};
    init.headers['Authorization'] = `Bearer ${token}`;

    return fetch(input, init);
}

export const authorizedPost = (input, data) => {
    return authorizedFetch(input, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });
}

export const authorizedUpload = (input, data) => {
    return authorizedFetch(input, {
        method: 'POST',
        body: data
    });
}

export const authorizedDelete = (input) => {
    return authorizedFetch(input, {
        method: 'DELETE'        
    });
}

export default authorizedFetch;
